import {UserStore} from "../stores/UserStore";

export default function () {

    let store = UserStore();

    let html = document.querySelector('html');

    let processTheme = (mode) => {
        html.classList.remove('dark', 'light', 'system');

        let toggleDarkTheme = (e) => {
            if (e.matches) {
                html.classList.add('dark');
            } else {
                html.classList.remove('dark');
            }
        }

        if (mode === 'system') {
            let darkThemeCondition = window.matchMedia("(prefers-color-scheme: dark)");
            darkThemeCondition.addEventListener("change", function (e) {
                toggleDarkTheme(e);
            });

            toggleDarkTheme(darkThemeCondition);
        }

        if (mode === 'light') {
            html.classList.add('light');
        }

        if (mode === 'dark') {
            html.classList.add('dark');
        }
    };

    let getTheme = () => {
        let user = store.data;
        return user && user.settings && user.settings.dark_mode ? user.settings.dark_mode : 'system';
    }

    store.$subscribe((mutation, state) => {
        processTheme(getTheme());
    });

    processTheme(getTheme());
}